// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_u4-0";